module.exports = __webpack_public_path__ + "static/media/image16.6d8c464a.jpg";